{
    "table_header__product_name": "Article",
    "table_header__quote_id": "ID devis",
    "table_header__order_id": "ID commande",
    "table_header__customer_id": "ID client",
    "table_header__quote_created": "Date",
    "table_header__valid_until": "Valable jusqu'au",
    "table_header__offer": "Devis",
    "table_header__status": "Statut",
    "table_header__order_date": "Date",
    "table_header__location": "Site",
    "table_header__customer": "Client",
    "table_header__total": "Total",
    "table_header__margin": "MB",
    "table_header__lines": "Lignes",
    "table_header__quantity": "Quantité",
    "table_header__sales_rep": "Commercial",
    "table_header__unit": "Unité",
    "table_header__price": "Prix",
    "table_header__clerk": "Saisi par"
}
